import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Login from "../views/login/Login.vue";
import Register from "../views/login/Register.vue";
import Forgot from "../views/login/Forgot.vue";
import userCenter from "../views/user/index.vue";

import { isMobile, isPcPath } from "../assets/js/tools";

Vue.use(VueRouter);

const routesMc = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: {
      keepAlive: true, //自定义属性,通过改属性动态设置保活
    },
    component: () => import("@/views/mc/index"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/mc/login/Login_mc"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/mc/login/Register"),
  },
  {
    path: "/forgot",
    name: "forgot",
    component: () => import("@/views/mc/login/Forgot"),
  },
  {
    path: "/course",
    name: "course",
    meta: {
      keepAlive: true, //自定义属性,通过改属性动态设置保活
    },
    component: () => import("@/views/mc/course"),
  },
  {
    path: "/course-detail",
    name: "course-detail",
    component: () => import("@/views/mc/course/detail"),
  },
  {
    path: "/examination",
    name: "examination",
    component: () => import("@/views/mc/examination"),
  },
  {
    path: "/exam-detail",
    name: "exam-detail",
    component: () => import("@/views/mc/examination/detail"),
  },
  {
    path: "/exam-result",
    name: "exam-result",
    component: () => import("@/views/mc/examination/result"),
  },
  {
    path: "/announcement",
    name: "announcement",
    component: () => import("@/views/mc/announcement"),
  },
  {
    path: "/announcementDetail",
    name: "announcementDetail",
    component: () => import("@/views/mc/announcement/detail"),
  },
  {
    path: "/user",
    name: "user",
    redirect: "user/trainingRecord",
    component: () => import("@/views/mc/user/index"),
    children: [
      {
        path: "trainingRecord",
        component: () => import("@/views/mc/user/trainingRecord"),
      },
      {
        path: "myExamination",
        component: () => import("@/views/mc/user/myExamination"),
      },
      {
        path: "userSet",
        component: () => import("@/views/mc/user/userSet"),
      },
      {
        path: "feedback",
        component: () => import("@/views/mc/user/feedback"),
      },
      {
        path: "forgotPwd",
        component: () => import("@/views/mc/user/forgotPwd"),
      },
    ],
  },
];

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: {
      keepAlive: true, //自定义属性,通过改属性动态设置保活
    },
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot,
  },
  {
    path: "/course",
    name: "course",
    meta: {
      keepAlive: true, //自定义属性,通过改属性动态设置保活
    },
    component: () => import("@/views/course"),
  },
  {
    path: "/course-detail",
    name: "course-detail",
    component: () => import("@/views/course/detail"),
  },
  {
    path: "/examination",
    name: "examination",
    component: () => import("@/views/examination"),
  },
  {
    path: "/exam-detail",
    name: "exam-detail",
    component: () => import("@/views/examination/detail"),
  },
  {
    path: "/exam-result",
    name: "exam-result",
    component: () => import("@/views/examination/result"),
  },
  {
    path: "/announcement",
    name: "announcement",
    component: () => import("@/views/announcement"),
  },
  {
    path: "/announcementDetail",
    name: "announcementDetail",
    component: () => import("@/views/announcement/detail"),
  },
  {
    path: "/user",
    name: "user",
    redirect: "user/trainingRecord",
    component: userCenter,
    children: [
      {
        path: "trainingRecord",
        component: () => import("@/views/user/trainingRecord"),
      },
      {
        path: "myExamination",
        component: () => import("@/views/user/myExamination"),
      },
      {
        path: "userSet",
        component: () => import("@/views/user/userSet"),
      },
      {
        path: "feedback",
        component: () => import("@/views/user/feedback"),
      },
      {
        path: "forgotPwd",
        component: () => import("@/views/user/forgotPwd"),
      },
    ],
  },
];

const router = new VueRouter({
  routes: isMobile() ? routesMc : routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const userInfoGet = async (next) => {
  console.log(store.state.user.id + "============111111111111");
  if (store.state.user.id) {
    next();
  } else {
    await store.dispatch("GetInfo");
    next();
  }
};

router.beforeEach(async (to, from, next) => {
  if (to.meta.isAuth) {
    // 需要登录
    if (store.state.token) {
      // 已经登录
      userInfoGet(next);
    } else {
      // 未登录
      next({ path: "/login" });
    }
  } else {
    if (store.state.token) {
      // 已经登录
      userInfoGet(next);
    } else {
      next();
    }
  }
});

export default router;
